import { combineReducers } from '@reduxjs/toolkit';
import createProductReducer from './create/createSlice';
import productListReducer from './list/listSlice';

const productSlice = combineReducers({
    create: createProductReducer,
    list: productListReducer,
});

export default productSlice;
